import { Footer } from "@design-system/layouts/CommonLayout";

type SectorsLayoutProps = {
  children: React.ReactNode;
};

export function SectorsLayout({ children }: SectorsLayoutProps) {
  return (
    <>
      <main>{children}</main>
      <Footer />
    </>
  );
}
